export default {
    loading: false,
    visible: false,
    cbs: [],
    old: '',
    rebind: true,
    data: {
        ItemsLegend: null,
        ScreenName: 'GiftCertificates',
        CustomSettings: null,
    },
    filter: '',
    filters:[],
    columns:[],
    type: '',
    col: 10,
    fixed: false,
    reset: false,
    default: '',
}